/**
 * Shared type definitions for Custom Forms
 * Used across RegistrationPreview and other form-related components
 */

/**
 * Represents a form item type object.
 */
export interface FormItemType {
  id: number
  name: string
  parameters?: Record<string, string>
}

/**
 * Represents a form item (question) object.
 */
export interface FormItem {
  id: string
  name: string
  description: string | null
  form_item_type: FormItemType
  is_enabled: number | boolean // API returns 0 or 1
  is_required: number | boolean // API returns 0 or 1
  is_reserved: number | boolean // API returns 0 or 1
  index: number
  group_id: string
  parameters?: {
    values?: Array<{
      name: string
      value: string
      index: number
    }>
    min_number?: string | number
    max_number?: string | number
    min?: string | number
    max?: string | number
    max_char?: string | number
  }
  created_at: string
  updated_at?: string
}

/**
 * Represents a form group (section) object.
 */
export interface FormGroup {
  id: string
  name: string
  description: string | null
  is_enabled: number | boolean // API returns 0 or 1
  is_reserved: number | boolean // API returns 0 or 1
  index: number
  form_id?: string
  items: FormItem[]
  created_at: string
  updated_at?: string
}

/**
 * Represents a custom form object with typed groups.
 */
export interface CustomForm {
  id: string
  name: string
  description: string | null
  groups: FormGroup[]
  created_at: string
  updated_at: string
}

/**
 * Form type enum for URL parameters
 */
export type FormType = 'team' | 'player'

/**
 * Form item type constants
 */
export const FORM_ITEM_TYPES = {
  TEXT_FIELD: 1,
  NUMBER_FIELD: 2,
  DROPDOWN: 3,
  CHECKBOX: 4,
  TEXT_AREA: 5,
  DATE: 6,
  BIRTH_DATE: 7,
  PHONE: 8,
  EMAIL: 9,
  URL: 10,
  COUNTRY: 11,
  PLAYER_POSITION: 12,
  HOCKEY_USA: 13,
  PLAYER_NUMBER: 14,
} as const
